<div class="small-devices">
  <div id="main-wrapper">
    <div class="site-wrapper-reveal personalise_content">
      <div class="blog-pages-wrapper section-space--ptb_90">
        <div class="row">
          <div class="col-lg-1"></div>
          <!--====== Blogs Sidecolumns Start ======-->
          <div class="col-lg-4 order-lg-2 order-2">
            <div class="page-sidebar-content-wrapper page-sidebar-right small-mt__40 tablet-mt__40">
              <!--====== Blogs Recent Post start ======-->
              <div
                class="sidebar-widget blog_sidebarwidget  widgeglobal_section_contentt-blog-recent-post blog_widgetpost wow blog_moveupsidebar move-up">
                <div class="blog_posttilte sidebar-widget-title global_section_header" role="heading">Recent Posts</div>
                <ul class="blog_ulpost">

                  <li class="blog_lipost">
                    <a href="postpandamic" class="blog_listanchortags global_section_content"
                      aria-label="Read Postpandamic Insights">The new
                      wave of Digital Marketing in the Post-Pandemic world</a>
                  </li>
                  <li class="blog_lipost">
                    <a href="migrate-cloud" class="blog_listanchortags global_section_content"
                      aria-label="Read migrate cloud Insights">Why is
                      cloud migration critical in the covid-19 scenario</a>
                  </li>
                  <li class="blog_lipost">
                    <a href="h1b-visa" class="blog_listanchortags global_section_content"
                      aria-label="Read H1-B Visa Insights">What is H1-B
                      Visa</a>
                  </li>
                  <li class="blog_lipost">
                    <a href="digital-partner" class="blog_listanchortags global_section_content"
                      aria-label="View digital partner">How to
                      choose your digital partner?</a>
                  </li>
                  <li class="blog_lipost">
                    <a href="cloud-cost-optimization" class="blog_listanchortags global_section_content"
                      aria-label="View Cloud Cost Optimization">Cloud
                      optimization strategies that drove 50% cost savings</a>
                  </li>
                </ul>
              </div>

              <!--====== Blogs Recent Post end ======-->
            </div>
          </div>
          <!--====== Blogs Sidecolumns End ======-->


          <!--====== Blogs Middele columns Start ======-->

          <div class="col-lg-7 order-lg-1 order-1">
            <div class="main-blog-wrap">
              <div class="single-blog-item">


                <div class="post-feature blog-thumbnail  wow blog_moveupsidebar move-up">
                  <img src="../../../assets/images/AI-casestudy-images/banner-image.png" class=" w-100"
                    alt="blogs banner" />
                </div>
                <div class="post-info lg-blog-post-info  wow  blog_moveupsidebar move-up">

                  <div class="post-title global_section_header mx-5" role="heading">Client Story: Protecting Personal
                    Identifiable Information (PII) using AI/ML</div>
                  <div class="post-meta mt-20">
                    <div class="post-author">

                    </div>
                    <div class="post-date">
                      <span class="far fa-calendar meta-icon"></span>
                      Jan, 2024
                    </div>
                    <div class="post-view">
                      <span class="meta-icon far fa-eye"></span>
                      450 views
                    </div>
                    <div class="post-read">
                      <i class="fa fa-book"></i>
                      3 min Read
                    </div>

                  </div>

                  <div class="mt-5">
                    <!-- <div class="global_section_header">Choose a fit-for-purpose and cost-effective cloud</div> -->

                    <p class="pt-2 global_section_content pt-4">
                      <b> Data Collection:</b> The first step is to collect the relevant data that needs to be redacted.
                      This may include documents, emails, databases, or any other sources containing sensitive
                      information.
                    </p>

                    <p class="pt-2 global_section_content pt-4">
                      <b> Text Extraction:</b> Once the data is collected, the next step is to extract the text from the
                      different sources. This can involve converting documents into machine-readable formats or
                      extracting text from structured databases.
                    </p>
                  </div>



                  <div class="mt-5">

                    <p class="pt-2 global_section_content pt-4">
                      <b>Processing:</b> The extracted text is then processed using various techniques to identify and
                      redact sensitive information. Custom Regular Expression (REGEX) patterns can be used to search for
                      specific patterns or formats of sensitive data like social security numbers or credit card
                      numbers. Named Entity Recognition (NER) algorithms can identify entities like names, addresses, or
                      medical terms. Rule-based logic and deny lists can be applied to identify and redact specific
                      keywords or phrases.
                    </p>

                    <p class="pt-2 global_section_content pt-4">
                      <b>Algorithm (BERT, Fine-tune BERT):</b> Advanced algorithms like Bidirectional Encoder
                      Representations from Transformers (BERT) can be utilized for more complex redaction tasks.
                      BERT-based models can be fine-tuned on specific datasets to improve the accuracy and effectiveness
                      of redaction, especially in cases where context and semantics play a crucial role.
                    </p>

                    <p class="pt-2 global_section_content pt-4">
                      <b>Output:</b> The final step is to generate the redacted output. This can be in the form of
                      updated documents, databases, or reports where the sensitive information has been replaced or
                      masked. The output should ensure that the redacted data is effectively removed or obfuscated,
                      while maintaining the integrity and structure of the original information.
                    </p>

                  </div>

                  <div class="mt-5">
                    <div class="post-feature blog-thumbnail  wow blog_moveupsidebar move-up">
                      <img src="../../../assets\images\blogs\pii-blog22.png" class="img-fluid"
                        style="width: 100%; height: auto" alt="blogs pii-blog2" />
                      <p class="pt-2 global_section_content pt-4">
                        When it comes to redacting images, we use an advanced AI/ML technology to detect text lists
                        within the image. Our solution then creates a bounding box directly on the pixel data, runs it
                        through our algorithm, and produces a masked image as the result.</p>
                    </div>


                    <div class="mt-5">
                      <div class="global_section_header" style="line-height: 50px;">Examples </div>
                      <div class="post-feature blog-thumbnail  wow blog_moveupsidebar move-up">
                        <img src="../../../assets\images\blogs\pii-blog2.png" class="img-fluid"
                          style="width: 100%; height: auto" alt="blogs pii-blog2" />
                      </div>
                    </div>

                    <div class="mt-5">
                      <div class="global_section_header">Text Redaction </div>
                      <div class="post-feature blog-thumbnail  wow blog_moveupsidebar move-up">
                        <img src="../../../assets\images\blogs\pii-blog3.png" class="img-fluid"
                          style="width: 100%; height: auto" alt="blogs pii-blog3" />
                      </div>
                    </div>

                    <div class="mt-5">
                      <div class="global_section_header">Image Redaction </div>
                      <div class="post-feature blog-thumbnail  wow blog_moveupsidebar move-up">
                        <img src="../../../assets\images\blogs\pii-blog4.png" class="img-fluid"
                          style="width: 100%; height: auto" alt="blogs pii-blog4" />
                      </div>
                    </div>

                    <div class="mt-5">
                      <div class="global_section_header">Entity extraction </div>
                      <p class="pt-2 global_section_content pt-4">
                        We leveraged NER algorithms to identify and extract named entities, such as people,
                        organizations, and locations, from the text data. It can be used for fraud detection and trend
                        analysis. </p>
                    </div>

                    <div class="mt-5">
                      <div class="global_section_header" style="line-height: 50px;">Build your AI/ML solution with us
                      </div>

                      <p class="pt-2 global_section_content pt-4">
                        Data redaction is one of the most prominent, one-in-a-thousand applications of AI/ML, and the
                        possibilities are virtually limitless. According to a McKinsey report, over 50% of companies
                        have already incorporated AI into at least one business function, with momentum continuing to
                        soar.</p>
                      <p class="pt-2 global_section_content pt-4">
                        Do you have an AI/ML idea that's been brewing in your mind? Whether it's optimizing your
                        business processes, enhancing customer experiences, or revolutionizing your industry, our
                        experts are here to collaborate with you every step of the way. Together, we'll explore the
                        untapped potential of AI/ML and turn your idea into reality. </p>
                    </div>


                    <div class="mt-5">
                      <p class="pt-2 global_section_content pt-4">
                        Team up with our AI/ML experts to push the boundaries of innovation. Talk to us. </p>
                    </div>
                  </div>

                </div>


              </div>
            </div>
          </div>
          <!--====== Blogs Middele columns End ======-->

        </div>
      </div>
    </div>
  </div>
</div>


<div class="container-fluid">
  <div class="post-title global_section_header text-center mt-5" role="heading" aria-level="2">Machine learning-powered
    recommendation engines</div>
  <div class="post-meta mt-20" style="display: flex; justify-content: center;">
    <div class="post-author">

    </div>
    <div class="post-date">
      <span class="meta-icon"><i class="fa-regular fa-calendar-days"></i></span>
      Mar, 2024
    </div>
    <div class="post-view view-item1">
      <span class="meta-icon"> <i class=" fa-solid fa-eye"></i></span>
      450 views
    </div>
    <div class="post-read view-item2">
      <i class="fa fa-book"></i>
      3 min Read
    </div>
  </div>

  <div class="post-feature blog-thumbnail mb-3  wow blog_moveupsidebar move-up">
    <br><br>
    <img src="../../../assets/images/banners/Machine-learning-banner-img.webp" class="img-fluid"
      style="width: 100%; height: auto !important" alt="Machine-learning-banner-img" />
  </div>

  <div class="row">
    <div class="col-md-4 p-5">
      <div class="tab m-3">
        <!-- Content for the first column -->

        <h3 class="pt-3" style="color: #A348E8; font-size:20px;"> Table of Contents</h3>
        <hr>
        <ul class="custom-list">
          <li class="tick">
            <a (click)="scrollToSection('solution')" role="button">Client's Objective</a>
            <hr>
          </li>
          <li class="tick">
            <a (click)="scrollToSection('process')" role="button">Solution</a>
            <hr>
          </li>
          <li class="tick">
            <a (click)="scrollToSection('processs')" role="button">Process</a>
            <hr>
          </li>
          <li class="tick">
            <a (click)="scrollToSection('Accordions')" role="button">Benefits to Business</a>
            <hr>
          </li>
          <li class="tick">
            <a (click)="scrollToSection('Empower')" role="button">Empower your business with our AI/ML expertise</a>
          </li>
        </ul>
        <div class="tabss">s
          <div
            class="sidebar-widget blog_sidebarwidget  widgeglobal_section_contentt-blog-recent-post blog_widgetpost wow blog_moveupsidebar move-up">
            <div class="blog_posttilte sidebar-widget-title global_section_header" role="heading" aria-level="3">Recent
              Posts</div>
            <ul class="blog_ulpost">
              <li class="blog_lipost">
                <a href="postpandamic" class="blog_listanchortags global_section_content"
                  aria-label="Read Postpandamic Insights">The new wave of Digital
                  Marketing in the Post-Pandemic world</a>
              </li>
              <li class="blog_lipost">
                <a href="migrate-cloud" class="blog_listanchortags global_section_content"
                  aria-label="Read migrate cloud Insights">Why is cloud migration
                  critical in the covid-19 scenario</a>
              </li>
              <li class="blog_lipost">
                <a href="h1b-visa" class="blog_listanchortags global_section_content"
                  aria-label="Read H1-B Visa Insights">What is H1-B Visa</a>
              </li>
              <li class="blog_lipost">
                <a href="digital-partner" class="blog_listanchortags global_section_content"
                  aria-label="View digital partner">How to choose your digital
                  partner?</a>
              </li>
              <li class="blog_lipost">
                <a href="cloud-cost-optimization" class="blog_listanchortags global_section_content"
                  aria-label="View Cloud Cost Optimization">Cloud optimization
                  strategies that drove 50% cost savings</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-7">
      <div class="blogs_subparacontent blog_content text-black">
        <div>
          <!-- <p class="global_section_content pt-4">How Maganti IT is leading the Charge in Personalization for Manufacturing E-commerce.</p> -->
          <p class="global_section_content pt-4">Over the years, we've all fallen into the trap of overbuying from our
            favorite e-commerce stores, thanks to those enticing personalized recommendations that seem to know exactly
            what we're looking for. Whether it's Netflix's 'You May Also Like...' feature or Amazon's tailored product
            suggestions, these sophisticated data filtering systems are changing how we interact with content, products,
            and services.</p>
          <p class="global_section_content pt-4">By merging the interests of both customers and businesses,
            recommendation engines are not only improving the customer experience but also boosting sales. It's a
            win-win situation for everyone involved!</p>
          <p class="global_section_content pt-4">For businesses, investing in cutting-edge data solutions is essential
            to decipher customer behavior patterns and unleash the full potential of their data. This capability allows
            businesses to make recommendations that can have a significant impact on their revenue.</p>
          <img src="../../../assets/images/machine-learning-images/img-1.webp" class="img-fluid"
            style="width: 100%; height: auto !important" alt="blogs pii-banner" />



          <div class="mt-5">
            <div class="global_section_header" id="solution">Client's Objective</div>
            <p class="global_section_content pt-4">Our client, a sensor retail supergiant sought to transform their
              website shopping experience by providing personalized product recommendations. Recognizing the
              significance of curated content navigation, they sought to seamlessly guide customers to relevant
              information on their website. Furthermore, their goal was to enhance engagement and maximize cross-selling
              opportunities on their e-commerce digital platform. </p>
          </div>
        </div>
        <div class="mt-5">
          <div class="global_section_header" id="process"> Solution </div>
          <div class="enlarged-image" id="enlargedContainer">
            <img src="" alt="Enlarged back" id="enlargedImage">
            <span class="back-button" id="backButton">&#8592;</span>
          </div>
        </div>

        <div class="mt-5">
          <p class="pt-2 global_section_content pt-4">
            Personalizing online stores can be achieved through recommendation engines. These AI/ML algorithms leverage
            user data, preferences, and search history to curate personalized item selections.
          </p>
          <!-- <b>Data Collection:</b> Our journey began with the meticulous collection of human facial images from various sources. These images were carefully segregated based on eight distinct expressions: Anger, Contempt, Disgust, Fear, Happy, Neutral, Sad, and Surprise.</p> -->

          <p class="pt-2 global_section_content pt-4">
            Our client's recommendation engine was built in such a way that it suggests 5 similar products for each
            catalog item, based on various parameters. For instance, if you've shown a preference for sensors with
            larger inner diameters, our algorithm takes note and adjusts its suggestions accordingly.
          </p>

          <!-- <div class="mt-5"> -->
          <p class="pt-2 global_section_content pt-4">
            To achieve this level of personalization, we've built a hybrid recommendation system that combines the power
            of collaborative filtering and content-based filtering techniques. By analyzing customer interactions such
            as purchases, views, likes, and searches, our system gains a comprehensive understanding of each customer's
            unique preferences and behaviors.
          </p>

          <!-- <div class="container">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="image-item">
                                            <img src="../../../assets/images/machine-learning-images/img-2.webp" class="img-fluid" style="width: 100%; height: auto !important" alt="blogs pii-banner" />
                                            <div class="image-overlay">
                                                <span class="search-icon">&#128269;</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>  -->
          <div class="container">
            <div class="row">
              <div *ngFor="let item of imageItems1" class="col-md-3">
                <div class="image-item">
                  <img [src]="item.src" class="w-100" alt="Machine learning-powered recommendation engines" />
                  <div class="image-overlay" (click)="showEnlargedImage(item.src)">
                    <span class="search-icon">
                      <img draggable="false" role="img" class="emoji" alt="🔍"
                        src="https://s.w.org/images/core/emoji/14.0.0/svg/1f50d.svg" style="height: 20px;">
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div id="enlargedContainer" *ngIf="isEnlargedVisible" class="enlarged-container">
              <div class="row enlargedrow">
                <img id="enlargedImage" [src]="enlargedImageSrc" alt="Enlarged Image" />
                <span id="backButton" (click)="hideEnlargedImage()">&#8592;</span>
              </div>
            </div>
          </div>



          <p class="pt-2 global_section_content pt-4">
            By integrating this advanced recommendation engine, our client's online store could offer an enhanced
            shopping experience with tailored product suggestions- making shopping more than just a transaction, but a
            journey of discovery.
          </p>
        </div>

        <div class="global_section_header" id="processs"> Process </div>
        <div class="mt-5">
          <div class="container">
            <div class="row">
              <div *ngFor="let item of imageItems2" class="col-md-3">
                <div class="image-item">
                  <img [src]="item.src" class="w-100" alt="Imagess" />
                  <div class="image-overlay" (click)="showEnlargedImage(item.src)">
                    <span class="search-icon">
                      <img draggable="false" role="img" class="emoji" alt="🔍"
                        src="https://s.w.org/images/core/emoji/14.0.0/svg/1f50d.svg" style="height: 20px;">
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div id="enlargedContainer" *ngIf="isEnlargedVisible" class="enlarged-container">
              <div class="row enlargedrow">
                <img id="enlargedImage" [src]="enlargedImageSrc" alt="Enlarged Image" />
                <span id="backButton" (click)="hideEnlargedImage()">&#8592;</span>
              </div>
            </div>
          </div>


          <div class="mt-5">
            <p class="pt-2 global_section_content pt-4">To effectively develop a recommendation engine, it’s important
              to understand the problem it aims to solve. This includes conducting market research, engaging with
              stakeholders, and defining objectives. Articulating the problem shapes the entire process, considering
              factors like user personalization, engagement, and sales.</p>
            <p class="pt-2 global_section_content pt-4"><b>(i) Collect and Explore the Data : </b>Data powers
              recommendation systems by capturing valuable Information about users, items, and interactions. This vital
              data can be sourced from diverse channels, such as user profiles, purchase history, reviews, and
              clickstream data. Analyzing and interpreting through techniques like data visualization and statistical
              analysis uncovers insightful recommendations. </p>
            <p class="pt-2 global_section_content pt-4"><b>(ii) Preprocess the Data : </b>Data preprocessing is a
              crucial, labor-intensive step. It includes handling missing values, duplicates, and outliers through data
              cleaning. Additionally, you may need to transform data, engineer features, and convert categorical
              variables for modeling. Preprocessing ensures accurate, complete, and analysis-ready data.</p>
            <p class="pt-2 global_section_content pt-4"><b>(iii) Selecting a Recommendation Algorithm : </b> The choice
              of recommendation algorithm depends on the nature of your data and the problem. Common approaches include:
            </p>
            <p class="pt-2 global_section_content pt-4"><b>- Cosine similarity : </b> Cosine similarity is a measure of
              similarity between two vectors of an inner product pace that measures the cosine of the angle between
              them. In other words, it is a measure of the orientation of the two vectors relative to each other. </p>

            <div class="container">
              <div class="row">
                <div *ngFor="let item of imageItems3" class="col-md-3">
                  <div class="image-item">
                    <img [src]="item.src" class="w-100" alt="Images" />
                    <div class="image-overlay" (click)="showEnlargedImage(item.src)">
                      <span class="search-icon">
                        <img draggable="false" role="img" class="emoji" alt="🔍"
                          src="https://s.w.org/images/core/emoji/14.0.0/svg/1f50d.svg" style="height: 20px;">
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div id="enlargedContainer" *ngIf="isEnlargedVisible" class="enlarged-container">
                <div class="row enlargedrow">
                  <img id="enlargedImage" [src]="enlargedImageSrc" alt="Enlarged Image" />
                  <span id="backButton" (click)="hideEnlargedImage()">&#8592;</span>
                </div>
              </div>
            </div>

            <p class="pt-2 global_section_content pt-4"><b>- Content-Based Filtering:</b> Using item attributes to make
              recommendations. </p>

            <div class="container">
              <div class="row">
                <div *ngFor="let item of imageItems4" class="col-md-3">
                  <div class="image-item">
                    <img [src]="item.src" class="w-100" alt="Image" />
                    <div class="image-overlay" (click)="showEnlargedImage(item.src)">
                      <span class="search-icon">
                        <img draggable="false" role="img" class="emoji" alt="🔍"
                          src="https://s.w.org/images/core/emoji/14.0.0/svg/1f50d.svg" style="height: 20px;">
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div id="enlargedContainer" *ngIf="isEnlargedVisible" class="enlarged-container">
                <div class="row enlargedrow">
                  <img id="enlargedImage" [src]="enlargedImageSrc" alt="Enlarged Image" />
                  <span id="backButton" (click)="hideEnlargedImage()">&#8592;</span>
                </div>
              </div>
            </div>



            <p class="pt-2 global_section_content pt-4"><b>- Hybrid Methods:</b> Combining collaborative and
              content-based approaches for improved accuracy.</p>
            <p class="pt-2 global_section_content pt-4"><b>- Matrix Factorization:</b> Reducing high-dimensional data to
              discover latent factors.</p>
            <p class="pt-2 global_section_content pt-4">We have established our client case with a foundation in
              content-based filtering; however, our expertise extends beyond this domain, allowing us to develop
              recommendation systems for various other use cases as well. Our capabilities encompass a diverse range of
              applications, enabling us to tailor recommendation algorithms to meet specific needs and enhance user
              experiences across different domains. Whether it's personalized content suggestions, product
              recommendations, or any other context where user preferences play a crucial role, we are well-equipped to
              design and implement effective recommendation systems that optimize user engagement and satisfaction.</p>
            <p class="pt-2 global_section_content pt-4"><b>(iv) Training the Model : </b> With the selected algorithm,
              you move on to training your recommendation model. This involves feeding the preprocessed data into the
              model and allowing it to learn patterns, user preferences, and item characteristics. Training might
              require adjusting model hyperparameters and selecting an appropriate loss function. Cross-validation
              techniques help ensure model robustness. </p>
            <p class="pt-2 global_section_content pt-4"><b>(v) Evaluating the Model : </b> Model evaluation is crucial
              to assess its performance accurately. We employed evaluation metrics such as Mean Absolute Error (MAE),
              Root Mean Square Error (RMSE), Precision, Recall, and F1-score, depending on the goals. Through rigorous
              testing, you gain insights into how well the recommendation engine is working and where it might need
              improvements. </p>
            <p class="pt-2 global_section_content pt-4"><b>(vi) Fine-Tuning the Model : </b> Based on the evaluation
              results, we iteratively fine-tuned the model. This involves tweaking hyperparameters, optimizing
              algorithms, or exploring different data representations. The goal is to improve the model's accuracy,
              relevance, and efficiency in providing recommendations. </p>
            <p class="pt-2 global_section_content pt-4"><b>(vii) Deploy the Model : </b> With the selected algorithm,
              you move on to training your recommendation model. This involves feeding the preprocessed data into the
              model and allowing it to learn patterns, user preferences, and item characteristics. Training might
              require adjusting model hyperparameters and selecting an appropriate loss function. Cross-validation
              techniques help ensure model robustness. </p>
          </div>


          <div class="mt-5">
            <div class="global_section_header">Benefits to Business</div>
            <p class="pt-2 global_section_content pt-4">Recommendation engines can bring several benefits to businesses,
              including increased sales, improved user experience, better product discovery, higher customer retention,
              and reduced churn. Here's how each benefit can be quantified with numbers:</p>
            <section id="Accordions">
              <div class="container-fluid">
                <div class="accordion_container ouropinions_accordtionsection">
                  <div *ngFor="let item of accordionItems; let i = index">
                    <div class="accordion_head ouropinions_accordtionheading global_sub_title" role="button"
                      aria-haspopup="true" tabindex="0" (click)="toggleAccordion(i)">
                      {{ item.title }}
                      <span class="plusminus">{{ isOpen[i] ? '-' : '+' }}</span>
                    </div>
                    <div class="accordion_body ouropinion_bodysection" *ngIf="isOpen[i]">
                      <div class="global_section_content ouropinion_subcontent">
                        {{ item.content }}
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </section>
            <div class="global_section_header" id="Empower">Empower your business with our AI/ML expertise</div>
            <p class="pt-2 global_section_content pt-4">The recommended system was successfully integrated with the
              client’s e-commerce website- resulting in enhanced user experience and personalization paving the way to
              increased revenue opportunities.</p>
            <p class="pt-2 global_section_content pt-4">Are you ready to power your e-commerce website with
              Recommendation systems and join the ranks of top e-commerce giants such as Amazon, Flipkart and more? Do
              you have any other AI/ML idea that's been brewing in your mind? Contact our experts for a custom AI/ML
              solution. Let’s Talk.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>